import type { MultiSelectDesignTokens, MultiSelectTokenSections } from '@primeuix/themes/types/multiselect';

export const root: MultiSelectTokenSections.Root = {
    background: '{formField.background}',
    disabledBackground: '{formField.disabledBackground}',
    filledBackground: '{formField.filledBackground}',
    filledHoverBackground: '{formField.filledHoverBackground}',
    filledFocusBackground: '{formField.filledFocusBackground}',
    borderColor: '{formField.borderColor}',
    hoverBorderColor: '{formField.hoverBorderColor}',
    focusBorderColor: '{formField.focusBorderColor}',
    invalidBorderColor: '{formField.invalidBorderColor}',
    color: '{formField.color}',
    disabledColor: '{formField.disabledColor}',
    placeholderColor: '{formField.placeholderColor}',
    invalidPlaceholderColor: '{formField.invalidPlaceholderColor}',
    shadow: '{formField.shadow}',
    paddingX: '{formField.paddingX}',
    paddingY: '{formField.paddingY}',
    borderRadius: '{formField.borderRadius}',
    focusRing: {
        width: '{formField.focusRing.width}',
        style: '{formField.focusRing.style}',
        color: '{formField.focusRing.color}',
        offset: '{formField.focusRing.offset}',
        shadow: '{formField.focusRing.shadow}'
    },
    transitionDuration: '{formField.transitionDuration}',
    sm: {
        fontSize: '{formField.sm.fontSize}',
        paddingX: '{formField.sm.paddingX}',
        paddingY: '{formField.sm.paddingY}'
    },
    lg: {
        fontSize: '{formField.lg.fontSize}',
        paddingX: '{formField.lg.paddingX}',
        paddingY: '{formField.lg.paddingY}'
    }
};

export const dropdown: MultiSelectTokenSections.Dropdown = {
    width: '2.5rem',
    color: '{formField.icon.color}'
};

export const overlay: MultiSelectTokenSections.Overlay = {
    background: '{overlay.select.background}',
    borderColor: '{overlay.select.borderColor}',
    borderRadius: '{overlay.select.borderRadius}',
    color: '{overlay.select.color}',
    shadow: '{overlay.select.shadow}'
};

export const list: MultiSelectTokenSections.List = {
    padding: '{list.padding}',
    gap: '{list.gap}',
    header: {
        padding: '{list.header.padding}'
    }
};

export const option: MultiSelectTokenSections.Option = {
    focusBackground: '{list.option.focusBackground}',
    selectedBackground: '{list.option.selectedBackground}',
    selectedFocusBackground: '{list.option.selectedFocusBackground}',
    color: '{list.option.color}',
    focusColor: '{list.option.focusColor}',
    selectedColor: '{list.option.selectedColor}',
    selectedFocusColor: '{list.option.selectedFocusColor}',
    padding: '{list.option.padding}',
    borderRadius: '{list.option.borderRadius}',
    gap: '{list.gap}'
};

export const optionGroup: MultiSelectTokenSections.OptionGroup = {
    background: '{list.optionGroup.background}',
    color: '{list.optionGroup.color}',
    fontWeight: '{list.optionGroup.fontWeight}',
    padding: '{list.optionGroup.padding}'
};

export const clearIcon: MultiSelectTokenSections.ClearIcon = {
    color: '{formField.iconColor}'
};

export const chip: MultiSelectTokenSections.Chip = {
    borderRadius: '{formField.borderRadius}'
};

export const emptyMessage: MultiSelectTokenSections.EmptyMessage = {
    padding: '{list.option.padding}'
};

export default {
    root,
    dropdown,
    overlay,
    list,
    option,
    optionGroup,
    chip,
    clearIcon,
    emptyMessage
} satisfies MultiSelectDesignTokens;
